export default {"src":"/_next/static/media/turnips.0f1dcbe5.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};